import React, { createContext, useContext, useEffect,useState} from "react";
import { useReducerAsync } from "use-reducer-async";
import _ from "lodash";
import { PaymentReducer, paymentInitialState, AsyncPaymentHandlers } from './PaymentReducer';


export const CheckoutContext = createContext();

const CheckoutContextProvider = (props) => {
    //const { businessConfig } = useContext(TenantContext);
    const [paymentData, paymentDispatch] = useReducerAsync(PaymentReducer, paymentInitialState, AsyncPaymentHandlers);
    return (
        <CheckoutContext.Provider value={{
            paymentData,
            paymentDispatch
        }}>
            {props.children}
        </CheckoutContext.Provider>
    )
}

export default CheckoutContextProvider